/**
 * Kuteerr Collection Page — v2.1
 * Embedded directly in collection-main.liquid <script> tag.
 * Exposes: window.KuteerrCollection  +  window.setView (global compat)
 */
(function () {
  'use strict';

  /* ── GUARD: only run on collection pages ─────────────── */
  const grid = document.getElementById('productGrid');
  if (!grid) return;

  /* ── DOM CACHE — queried once ─────────────────────────── */
  const dom = {
    grid,
    countEl:          document.getElementById('productCount'),
    noResults:        document.getElementById('noResults'),
    activeFiltersRow: document.getElementById('activeFilters'),
    priceSlider:      document.getElementById('priceSlider'),
    priceMaxLabel:    document.getElementById('priceMax'),
    wishCountEl:      document.getElementById('wishCount'),
    gridViewBtn:      document.getElementById('gridViewBtn'),
    listViewBtn:      document.getElementById('listViewBtn'),
    filterPills:      document.getElementById('filterPills'),
    sortSelect:       document.getElementById('sortSelect'),
    filterDrawer:     document.getElementById('filterDrawer'),
    filterOverlay:    document.getElementById('filterOverlay'),
    filterClose:      document.getElementById('filterClose'),
    filterDrawerBtn:  document.getElementById('filterDrawerBtn'),
  };

  /* ── STATE — single source of truth ──────────────────── */
  const state = {
  filters: {},   // dynamic groups
  priceMax: Infinity,
  activeTag: 'all',
  wishCount: 0,
};

  /* ── CARDS CACHE ──────────────────────────────────────── */
  let cards = Array.from(grid.querySelectorAll('.p-card'));

  /* ══════════════════════════════════════════════════════
     CORE — single combined filter pass
  ══════════════════════════════════════════════════════ */
  // function applyFilters() {
  //   const hasCraft   = state.craft.size    > 0;
  //   const hasCat     = state.category.size > 0;
  //   const hasAvail   = state.avail.size    > 0;
  //   const hasTag     = state.activeTag !== 'all';
  //   const hasPrice   = state.priceMax !== Infinity;
  //   let visible = 0;

  //   requestAnimationFrame(function () {
  //     cards.forEach(function (card) {
  //       const craft  = card.dataset.craft  || '';
  //       const cat    = card.dataset.cat    || '';
  //       const badge  = card.dataset.badge  || '';
  //       const avail  = card.dataset.avail  || '';
  //       const price  = parseInt(card.dataset.price, 10) || 0;

  //       const craftOk  = !hasCraft  || state.craft.has(craft);
  //       const catOk    = !hasCat    || state.category.has(cat);
  //       const availOk  = !hasAvail  || state.avail.has(avail);
  //       const priceOk  = !hasPrice  || price <= state.priceMax;
  //       const tagOk    = !hasTag    || craft === state.activeTag ||
  //                        badge === state.activeTag || cat === state.activeTag;

  //       const show = craftOk && catOk && availOk && priceOk && tagOk;
  //       card.classList.toggle('p-card--hidden', !show);
  //       if (show) visible++;
  //     });

  //     if (dom.countEl) {
  //       dom.countEl.textContent = visible + (visible === 1 ? ' piece' : ' pieces');
  //     }
  //     if (dom.noResults) {
  //       dom.noResults.classList.toggle('hidden', visible > 0);
  //     }
  //   });
  // }

  function applyFilters() {
  const activeGroups = Object.keys(state.filters).filter(
    (g) => state.filters[g] && state.filters[g].size > 0
  );

  const hasTag   = state.activeTag !== 'all';
  const hasPrice = state.priceMax !== Infinity;

  let visible = 0;

  requestAnimationFrame(function () {
    cards.forEach(function (card) {
      const price = parseInt(card.dataset.price, 10) || 0;

      let groupOk = true;

      for (const group of activeGroups) {
        const cardVal = (card.dataset[group] || '').toString();
        if (!state.filters[group].has(cardVal)) {
          groupOk = false;
          break;
        }
      }

      const priceOk = !hasPrice || price <= state.priceMax;

      const tagOk = !hasTag ||
        card.dataset.craft === state.activeTag ||
        card.dataset.badge === state.activeTag ||
        card.dataset.cat === state.activeTag;

      const show = groupOk && priceOk && tagOk;

      card.classList.toggle('p-card--hidden', !show);
      if (show) visible++;
    });

    if (dom.countEl) {
      dom.countEl.textContent =
        visible + (visible === 1 ? ' piece' : ' pieces');
    }

    if (dom.noResults) {
      dom.noResults.classList.toggle('hidden', visible > 0);
    }
  });
}

  /* ══════════════════════════════════════════════════════
     FILTER PILLS — event delegation on container
  ══════════════════════════════════════════════════════ */
  if (dom.filterPills) {
    dom.filterPills.addEventListener('click', function (e) {
      const btn = e.target.closest('.filter-pill[data-filter]');
      if (!btn) return;
      dom.filterPills.querySelectorAll('.filter-pill').forEach(function (p) {
        p.classList.remove('active');
      });
      btn.classList.add('active');
      state.activeTag = btn.dataset.filter || 'all';
      applyFilters();
    });
  }

  function ensureGroup(group) {
    if (!state.filters[group]) {
      state.filters[group] = new Set();
    }
    return state.filters[group];
  }

  /* ══════════════════════════════════════════════════════
     SIDEBAR CHECKBOX FILTERS
     Called via onclick="KuteerrCollection.toggleCheck(...)"
  ══════════════════════════════════════════════════════ */
  function toggleCheck(label, group, val) {
  if (!label || !group || !val) return;

  const set = ensureGroup(group);
  const isChecked = !label.classList.contains('checked');

  label.classList.toggle('checked', isChecked);

  const svg = label.querySelector('.check-box svg');
  if (svg) svg.style.display = isChecked ? 'block' : 'none';

  if (isChecked) set.add(val);
  else set.delete(val);

  applyFilters();
  renderActiveFilters();
}

  function clearFilter(group) {
    if (!state[group]) return;
    state[group].clear();
    document.querySelectorAll('[data-group="' + group + '"]').forEach(function (label) {
      label.classList.remove('checked');
      const svg = label.querySelector('.check-box svg');
      if (svg) svg.style.display = 'none';
    });
    applyFilters();
    renderActiveFilters();
  }

  function clearAllFilters() {
  state.filters = {};
  state.priceMax = Infinity;
  state.activeTag = 'all';

  document.querySelectorAll('.filter-check').forEach(function (label) {
    label.classList.remove('checked');
    const svg = label.querySelector('.check-box svg');
    if (svg) svg.style.display = 'none';
  });

  const allPill = document.querySelector('.filter-pill[data-filter="all"]');
  if (allPill) {
    document.querySelectorAll('.filter-pill').forEach(function (p) {
      p.classList.remove('active');
    });
    allPill.classList.add('active');
  }

  if (dom.priceSlider) dom.priceSlider.value = dom.priceSlider.max;
  if (dom.priceMaxLabel) dom.priceMaxLabel.textContent = '';

  applyFilters();
  renderActiveFilters();
}

  /* ── Active filter chips (DocumentFragment = 1 reflow) ── */
  function renderActiveFilters() {
  if (!dom.activeFiltersRow) return;

  const all = [];

  Object.keys(state.filters).forEach(function (group) {
    state.filters[group].forEach(function (val) {
      all.push({ group, val });
    });
  });

  if (all.length === 0) {
    dom.activeFiltersRow.classList.add('hidden');
    dom.activeFiltersRow.innerHTML = '';
    return;
  }

  dom.activeFiltersRow.classList.remove('hidden');

  const frag = document.createDocumentFragment();

  all.forEach(function (item) {
    const btn = document.createElement('button');
    btn.className = 'af-chip';
    btn.dataset.group = item.group;
    btn.dataset.value = item.val;

    btn.innerHTML = item.val +
      '<svg width="9" height="9" fill="none" stroke="currentColor" stroke-width="1.6">' +
      '<path d="M8 1 1 8M1 1l7 7"/></svg>';

    frag.appendChild(btn);
  });

  const clearBtn = document.createElement('button');
  clearBtn.className = 'af-chip af-chip--clear';
  clearBtn.textContent = 'Clear all';
  clearBtn.addEventListener('click', clearAllFilters);
  frag.appendChild(clearBtn);

  dom.activeFiltersRow.innerHTML = '';
  dom.activeFiltersRow.appendChild(frag);
}

  /* Delegate chip removal */
  if (dom.activeFiltersRow) {
  dom.activeFiltersRow.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-group]');
    if (!btn) return;

    const group = btn.dataset.group;
    const val = btn.dataset.value;

    if (state.filters[group]) {
      state.filters[group].delete(val);
    }

    document.querySelectorAll(
      '[data-group="' + group + '"][data-filter-val="' + val + '"]'
    ).forEach(function (label) {
      label.classList.remove('checked');
      const svg = label.querySelector('.check-box svg');
      if (svg) svg.style.display = 'none';
    });

    applyFilters();
    renderActiveFilters();
  });
}

  /* ══════════════════════════════════════════════════════
     SORT — client-side instant sort
  ══════════════════════════════════════════════════════ */
  function sortProducts(val) {
    const visible = cards.filter(function (c) { return !c.classList.contains('p-card--hidden'); });
    const hidden  = cards.filter(function (c) { return  c.classList.contains('p-card--hidden'); });

    visible.sort(function (a, b) {
      switch (val) {
        case 'price-ascending':
          return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10);
        case 'price-descending':
          return parseInt(b.dataset.price, 10) - parseInt(a.dataset.price, 10);
        case 'title-ascending':
          return (a.dataset.name || '').localeCompare(b.dataset.name || '');
        case 'title-descending':
          return (b.dataset.name || '').localeCompare(a.dataset.name || '');
        default: return 0;
      }
    });

    cards = visible.concat(hidden);
    const frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    requestAnimationFrame(function () { dom.grid.appendChild(frag); });
  }

  /* ── Sort select: client-side for instant feedback ─── */
  if (dom.sortSelect) {
    dom.sortSelect.addEventListener('change', function () {
      sortProducts(this.value);
    });
    /* Remove the inline onchange that does page redirect for sort
       — we handle it client-side above */
    dom.sortSelect.removeAttribute('onchange');
  }

  /* ══════════════════════════════════════════════════════
     VIEW TOGGLE (grid / list) — localStorage persisted
  ══════════════════════════════════════════════════════ */
  function setView(mode) {
    var isGrid = mode === 'grid';
    requestAnimationFrame(function () {
      dom.grid.classList.toggle('view-list',  !isGrid);
      dom.grid.classList.toggle('view-grid',   isGrid);
    });
    if (dom.gridViewBtn) {
      dom.gridViewBtn.classList.toggle('active',  isGrid);
      dom.gridViewBtn.setAttribute('aria-pressed', String(isGrid));
    }
    if (dom.listViewBtn) {
      dom.listViewBtn.classList.toggle('active', !isGrid);
      dom.listViewBtn.setAttribute('aria-pressed', String(!isGrid));
    }
    try { localStorage.setItem('kuteerr-view', mode); } catch (e) {}
  }

  /* Restore on load */
  (function () {
    var saved = 'grid';
    try { saved = localStorage.getItem('kuteerr-view') || 'grid'; } catch (e) {}
    setView(saved);
  }());

  /* ══════════════════════════════════════════════════════
     PRICE RANGE — debounced 80ms
  ══════════════════════════════════════════════════════ */
  var priceTimer = null;
  function updatePrice(val) {
    var n = parseInt(val, 10);
    state.priceMax = n;
    if (dom.priceMaxLabel) {
      dom.priceMaxLabel.textContent = '\u20B9' + n.toLocaleString('en-IN');
    }
    clearTimeout(priceTimer);
    priceTimer = setTimeout(applyFilters, 80);
  }

  /* ══════════════════════════════════════════════════════
     WISHLIST — delegated on grid
  ══════════════════════════════════════════════════════ */
  dom.grid.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wish-btn]');
    if (!btn) return;
    const isActive = btn.classList.toggle('active');
    state.wishCount += isActive ? 1 : -1;
    if (dom.wishCountEl) {
      dom.wishCountEl.textContent = state.wishCount;
      dom.wishCountEl.classList.toggle('hidden', state.wishCount === 0);
    }
  });

  /* ══════════════════════════════════════════════════════
     MOBILE FILTER DRAWER
  ══════════════════════════════════════════════════════ */
  function openDrawer() {
    if (!dom.filterDrawer) return;
    dom.filterDrawer.classList.add('open');
    dom.filterDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (dom.filterDrawerBtn) dom.filterDrawerBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!dom.filterDrawer) return;
    dom.filterDrawer.classList.remove('open');
    dom.filterDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (dom.filterDrawerBtn) dom.filterDrawerBtn.setAttribute('aria-expanded', 'false');
  }

  if (dom.filterDrawerBtn) dom.filterDrawerBtn.addEventListener('click', openDrawer);
  if (dom.filterClose)     dom.filterClose.addEventListener('click', closeDrawer);
  if (dom.filterOverlay)   dom.filterOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ══════════════════════════════════════════════════════
     PAGINATION scroll-to-grid
  ══════════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    const pgBtn = e.target.closest('.pg-btn:not([data-pg-arrow])');
    if (!pgBtn) return;
    document.querySelectorAll('.pg-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    pgBtn.classList.add('active');
    window.scrollTo({
      top: dom.grid.getBoundingClientRect().top + window.scrollY - 140,
      behavior: 'smooth'
    });
  });

  /* ══════════════════════════════════════════════════════
     PUBLIC API
     window.setView   → onclick="setView('grid')" in filter-bar
     window.KuteerrCollection → onclick="KuteerrCollection.toggleCheck(...)"
  ══════════════════════════════════════════════════════ */
  window.setView = setView;   /* keeps filter-bar onclick="setView()" working */
  window.KuteerrCollection = {
    toggleCheck,
    clearFilter,
    clearAllFilters,
    updatePrice,
    setView,
  };

}());